'use strict';

window.CI360 = {
    notInitOnLoad: true
};

require('site');
require('slick-carousel');
require('film');
require('dialog');
require('tab');
require("js-cloudimage-360-view");
require('video');
const lozad = require('lozad');
const BeforeAfter = require('before-after');

$(document).ready
(
    function()
    {
        const $element = $("[data-before-after]");

        if($element.length)
        {
            const beforeAfterItem = new BeforeAfter({
                element: $element.get(0),
                cursor: true,
                selectors: {
                    item: '.beforeafter__item',
                    itemActive: '.beforeafter__item--active',
                    cursor: '.beforeafter__cursor',
                    imageWrapper: '.beforeafter__wrapper',
                }
            });

            beforeAfterItem.create();
        }
    }
);

$(document).ready
(
    function()
    {
        const observer = lozad();
        observer.observe();
    }
);

$(document).ready
(
    function() {
        $("VIDEO").video();
    }
);

$(document).ready
(
    function() {
        $("[data-feedback-dialog-button]").click(function()
        {
            const $dialog = $("[data-feedback-dialog]");
            $dialog.dialog(true);

            return false;
        });
    }
);

$(document).ready
(
    function()
    {
        $("[data-film]").film({
            blocks: $("[data-film] [data-film-block]"),
            images: $("[data-film] [data-film-image]")
        });
    }
);

$(document).ready
(
    function()
    {
        const $slider = $('[data-brands]');

        if($slider.length)
        {
            $slider.find('[data-brands-items]').slick
            (
                {
                    lazyLoad: 'ondemand',
                    cssEase: 'linear',
                    autoplay: true,
                    autoplaySpeed: 0,
                    pauseOnHover: true,
                    accessibility: true,
                    adaptiveHeight: true,
                    dots: false,
                    fade: false,
                    speed: 3000,
                    arrows: false,
                    slidesToShow: 7,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 1100,
                            settings: {
                                slidesToShow: 6
                            }
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 5
                            }
                        },
                        {
                            breakpoint: 900,
                            settings: {
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 850,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 300,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                }
            );
        }
    }
);

$(document).ready
(
    function()
    {
        function toSliderServices($slider)
        {
            $slider.on("init", function()
            {
                window.CI360.init();
            });

            $slider.slick
            (
                {
                    cssEase: 'linear',
                    autoplay: false,
                    autoplaySpeed: 0,
                    pauseOnHover: true,
                    accessibility: true,
                    adaptiveHeight: true,
                    dots: false,
                    fade: false,
                    speed: 400,
                    arrows: true,
                    slidesToShow: 4,
                    infinite: true,
                    centerMode: true,
                    responsive: [
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 700,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 450,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                }
            );
        }

        function toSliderExample($slider)
        {
            $slider.slick
            (
                {
                    cssEase: 'linear',
                    autoplay: false,
                    autoplaySpeed: 0,
                    pauseOnHover: true,
                    accessibility: true,
                    adaptiveHeight: true,
                    dots: false,
                    fade: false,
                    speed: 400,
                    arrows: true,
                    slidesToShow: 1,
                    infinite: true,
                }
            );
        }

        const $tab = $('[data-tab]');
        let $slider;

        if($tab.length) $slider = $tab.find('[data-services]:eq(0) [data-services-items]');
        else $slider = $('[data-services] [data-services-items]');

        const $sliderExamples = $('[data-examplse]');

        if($slider.length)
        {
            const $sliderExamples = $slider.find('[data-examplse]');

            toSliderServices($slider);
            toSliderExample($sliderExamples);

            if($tab.length)
            {
                const $triggers = $tab.find('[data-tab-trigger]');
                const $contents = $tab.find('[data-tab-content]');

                $tab.tab
                (
                    {
                        triggers: $triggers,
                        contents: $contents,
                        click: function($trigger, $content) {
                            $triggers.removeClass(["button--border-blue-light", "button--color-blue-light"]).addClass("button--border-grey");
                            $trigger.addClass(["button--border-blue-light", "button--color-blue-light"]);

                            const $slickVisible = $contents.filter(":visible").find("[data-services] [data-services-items]");
                            const $slickHide = $content.find('[data-services] [data-services-items]');

                            const $examplesVisible = $slickVisible.find("[data-examplse]");
                            const $examplesHide = $slickHide.find('[data-examplse]');

                            const $visibles = $contents.filter(":visible");

                            $slickHide.find(".card__description, .card__title").css("display", "none");

                            toSliderServices($slickHide);
                            toSliderExample($examplesHide);

                            $visibles.fadeOut(200, function()
                            {
                                $content.fadeIn(400, function()
                                {
                                    $slickVisible.slick('unslick');
                                    $examplesVisible.slick('unslick');

                                    $(window).trigger('resize');

                                    window.setTimeout(function()
                                    {
                                        $slickHide.find(".card__description, .card__title").css("display", "block");
                                    }, 100);

                                    if(window.CI360)
                                    {
                                        window.CI360.init();
                                    }
                                });
                            });
                        },
                    },
                );
            }
        }
        else if($sliderExamples.length)
        {
            toSliderExample($sliderExamples);
        }
    }
);

$(document).ready
(
    function()
    {
        const $slider = $('[data-reviews]');

        if($slider.length)
        {
            $slider.slick
            (
                {
                    lazyLoad: 'ondemand',
                    cssEase: 'linear',
                    autoplay: false,
                    autoplaySpeed: 0,
                    pauseOnHover: true,
                    accessibility: true,
                    adaptiveHeight: true,
                    dots: true,
                    fade: false,
                    speed: 400,
                    arrows: true,
                    slidesToShow: 2,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 850,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                }
            );
        }
    }
);
